// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__SeJQC","errorLogs":"EditorFooter_errorLogs__xW2FL"};